import { ContentContainer, WaitingsubTitle, WaitingTitle } from './styled';

export const Waiting = () => (
  <ContentContainer>
    <WaitingTitle>First-class Impressions are Waiting for You!</WaitingTitle>
    <WaitingsubTitle>
        Our agency offers travelers various tours and excursions with destinations
        all over the world. Browse our website to find your dream tour!
    </WaitingsubTitle>
  </ContentContainer>
);
